import {
  IconSmartHome,
  IconMap,
  IconBuildingCottage,
  IconUsers,
  IconUserCheck,
  IconList,
  IconDroplet,
  IconFileText,
  IconCamera,
} from "@tabler/icons-react";

export const ROLE = {
  superadmin: "superadmin",
  damManagement: "dam-management",
  accountManagement: "account-management",
  postManagement: "post-management",
};

export const getDashboardAdmin = (arrRole: string[]) => {
  const isSuperAdmin = arrRole.includes(ROLE.superadmin);
  const isPostManagement = arrRole.includes(ROLE.postManagement);
  const isAccountManagement = arrRole.includes(ROLE.accountManagement);
  const isDamManagement = arrRole.includes(ROLE.damManagement);

  return [
    {
      id: "guest-group",
      title: "Khách",
      type: "group",
      children: [
        {
          id: "home",
          title: "Trang chủ",
          type: "item",
          url: "/home",
          icon: <IconSmartHome stroke={1.5} />,
          breadcrumbs: true,
        },
        {
          id: "about-us",
          title: "Giới thiệu",
          type: "item",
          url: "/about-us",
          icon: <IconMap stroke={1.5} />,
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "admin-group",
      title: "Quản trị",
      type: "group",
      // Ẩn cả group nếu không có quyền nào trong nhóm
      children: [
        isSuperAdmin || isAccountManagement
          ? {
              id: "admin-account",
              title: "Quản lý tài khoản",
              type: "item",
              url: "/account-management",
              icon: <IconUsers stroke={1.5} />,
              breadcrumbs: true,
            }
          : null,
        isSuperAdmin
          ? {
              id: "admin-role",
              title: "Quản lý vai trò",
              type: "item",
              url: "/role-management",
              icon: <IconUserCheck stroke={1.5} />,
              breadcrumbs: true,
            }
          : null,
        isSuperAdmin || isDamManagement
          ? {
              id: "admin-dam",
              title: "Quản lý cống/đập",
              type: "item",
              url: "/dam-management",
              icon: <IconBuildingCottage stroke={1.5} />,
              breadcrumbs: true,
            }
          : null,
        isSuperAdmin || isDamManagement
          ? {
              id: "admin-dam-type",
              title: "Quản lý loại cống/đập",
              type: "item",
              url: "/dam-type-management",
              icon: <IconList stroke={1.5} />,
              breadcrumbs: true,
            }
          : null,
        isSuperAdmin || isDamManagement
          ? {
              id: "admin-river",
              title: "Quản lý sông",
              type: "item",
              url: "/river-management",
              icon: <IconDroplet stroke={1.5} />,
              breadcrumbs: true,
            }
          : null,

        isSuperAdmin || isPostManagement
          ? {
              id: "admin-post",
              title: "Quản lý bài viết",
              type: "item",
              url: "/post-management",
              icon: <IconFileText stroke={1.5} />,
              breadcrumbs: true,
            }
          : null,
        isSuperAdmin
          ? {
              id: "admin-device",
              title: "Quản lý camera",
              type: "item",
              url: "/camera-management",
              icon: <IconCamera stroke={1.5} />,
              breadcrumbs: true,
            }
          : null,
      ].filter(Boolean), // lọc bỏ các null
    },
  ].filter((group) => group.children.length > 0); // ẩn group rỗng
};
